import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import Login from "./Login";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "./Layout";
import CustomerSelfService from "./pages/CustomerSelfService";
import Dashboard from "./pages/Dashboard";
import NewRental from "./pages/NewRental";
import Rentals from "./pages/Rentals";
import RentalDetail from "./pages/RentalDetail";
import Items from "./pages/Items";
import ItemDetail from "./pages/ItemDetail";
import Equipment from "./pages/Equipment";
import Locations from "./pages/Locations";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import QrCatalog from "./pages/QrCatalog";
import Recap from "./pages/Recap";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          {/* Öffentlich — Kunde scannt QR und meldet sich selbst an */}
          <Route path="/rental" element={<CustomerSelfService />} />
          <Route path="/login" element={<Login />} />

          {/* Staff/Admin — Login erforderlich */}
          <Route
            path="/admin"
            element={<Navigate to="/dashboard" replace />}
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="rental/new" element={<NewRental />} />
            <Route path="rentals" element={<Rentals />} />
            <Route path="rentals/:rentalId" element={<RentalDetail />} />
            <Route path="items" element={<Items />} />
            <Route path="items/:itemId" element={<ItemDetail />} />
            <Route path="admin/equipment" element={<ProtectedRoute requireAdmin><Equipment /></ProtectedRoute>} />
            <Route path="admin/locations" element={<ProtectedRoute requireAdmin><Locations /></ProtectedRoute>} />
            <Route path="admin/users" element={<ProtectedRoute requireAdmin><Users /></ProtectedRoute>} />
            <Route path="admin/qr-catalog" element={<ProtectedRoute requireAdmin><QrCatalog /></ProtectedRoute>} />
            <Route path="admin/recap" element={<ProtectedRoute requireAdmin><Recap /></ProtectedRoute>} />
            <Route path="admin/settings" element={<ProtectedRoute requireAdmin><Settings /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
